import React from "react";

import PatientLogo from "../images/patient-logo.svg";
import HCPLogo from "../images/hcp-logo.svg";

import { blueGradient, white, transparentGray, lightBlue } from "./base/colors";
import Flex from "./base/flex";
import Box from "./base/box";
import Text from "./base/text";
import Image from "./base/image";
import Link from "./base/link";
import Button from "./base/button";

import SecondaryNavigation from "./secondary-navigation";
import SecondaryNavLinks from "./secondary-nav-links";
import MobileNav from "./mobileNav";

import Navigation from "./navigation";
import useGetBrowserSize from "../hooks/use-is-mobile";
import { useContentContext } from "../context/content-context";

const CONTENT = {
  patient: {
    logo: PatientLogo,
    logoUrl: "/",
    background: blueGradient,
    NavigationComponent: Navigation,
  },
  hcp: {
    logo: HCPLogo,
    logoUrl: "/hcp/",
    background: white,
    NavigationComponent: Navigation,
  },
};

const Header = ({
  variant,
  isMobileNavOpen,
  setIsMobileNavOpen,
  ISIScrollButton,
}) => {
  const { isDesktop } = useGetBrowserSize();
  const { isHCP, language } = useContentContext();

  const mobileHandleISIClick = () => {
    setIsMobileNavOpen(false);
  };

  const { logo, logoUrl, background, NavigationComponent } = CONTENT[variant];

  return (
    <>
      {isHCP && (
        <Flex
          padding="13px 0"
          justifyContent="center"
          background={blueGradient}
          role="navigation"
          aria-label="tertiary"
        >
          <Flex
            width="100%"
            maxWidth="1200px"
            justifyContent={["center", "center", "space-between"]}
          >
            <Text fontSize="16px" color="white">
              For US healthcare professionals only
            </Text>
            {isDesktop && (
              <SecondaryNavigation ISIScrollButton={ISIScrollButton}>
                <SecondaryNavLinks />
              </SecondaryNavigation>
            )}
          </Flex>
        </Flex>
      )}
      <Box
        justifyContent="center"
        padding={["32px 28px", "32px", "30px 32px 26px"]}
        display="flex"
        background={background}
        role="banner"
        position="relative"
        zIndex={2}
        height={["104px", "124px", "111px"]}
        boxShadow={`0px 3px 6px ${transparentGray}`}
      >
        <Flex
          width="100%"
          maxWidth="1200px"
          alignItems="center"
          justifyContent="space-between"
        >
          <Link
            width="fit-content"
            maxWidth="325px"
            href={language === "esp" ? logoUrl + "es" : logoUrl}
          >
            <Image
              alt="FUROSCIX Logo"
              height={["40px", "60px", "55px"]}
              src={logo}
            />
          </Link>
          <Flex
            as="nav"
            justifyContent={
              isHCP
                ? ["center", "center", "flex-end"]
                : ["center", "center", "space-between"]
            }
            flexDirection="column"
            alignItems="flex-end"
            height={isHCP ? "65px" : "unset"}
            aria-label="primary"
            maxWidth={isHCP ? "840px" : "unset"}
          >
            {isDesktop ? (
              <>
                {!isHCP && (
                  <SecondaryNavigation ISIScrollButton={ISIScrollButton}>
                    <SecondaryNavLinks />
                  </SecondaryNavigation>
                )}
                <NavigationComponent variant="navigation" />
              </>
            ) : (
              <Button
                flexDirection="column"
                padding={0}
                width="38px"
                variant="unstyled"
                onClick={() => setIsMobileNavOpen(!isMobileNavOpen)}
                height="18px"
                aria-label="mobile navigation toggle"
              >
                <Box
                  width="100%"
                  mb="6px"
                  borderBottom={
                    isHCP ? `3px solid ${lightBlue}` : "3px solid #FFFFFF"
                  }
                  borderRadius="5px"
                  style={{
                    transformOrigin: "center",
                    transform:
                      isMobileNavOpen && "rotate(45deg) translatey(13px)",
                    transition: "all 0.5s ease",
                  }}
                />
                <Box
                  width="100%"
                  mb="6px"
                  borderBottom={
                    isHCP ? `3px solid ${lightBlue}` : "3px solid #FFFFFF"
                  }
                  style={{
                    transition: "all 0.5s ease",
                    opacity: isMobileNavOpen ? 0 : 1,
                  }}
                  borderRadius="5px"
                />
                <Box
                  width="100%"
                  borderRadius="5px"
                  borderBottom={
                    isHCP ? `3px solid ${lightBlue}` : "3px solid #FFFFFF"
                  }
                  style={{
                    transformOrigin: "center",
                    transform:
                      isMobileNavOpen && "rotate(-45deg) translatey(-13px)",
                    transition: "all 0.5s ease",
                  }}
                />
              </Button>
            )}
          </Flex>
        </Flex>
      </Box>
      {isMobileNavOpen && (
        <MobileNav
          handleISIClick={mobileHandleISIClick}
          ISIScrollButton={ISIScrollButton}
        />
      )}
    </>
  );
};

export default Header;
